import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {enumValidValueItem} from '../../ar/_models/ar.models';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {OrganizationContactDataModel} from '../../../models/organization/organization-contact-data.model';
import {AddressDataModel} from '../../../models/person/address-data.model';
import {OrganizationAddressDataModel} from '../../../models/organization/organization-address-data.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  constructor(private http: HttpClient) { }

  createOrganization(): Observable<OrganizationDataModel> {
    return this.http.post<OrganizationDataModel>(`/api/organizations/create-organization`, {});
  }

  saveOrganizations(organizations: OrganizationDataModel[]): Observable<OrganizationDataModel[]> {
    return this.http.post<OrganizationDataModel[]>('/api/organizations/save-organizations', organizations);
  }

  deleteOrganizationContact(contactId: string) {
    return this.http.get<void>(`/api/organizations/delete-organization-contact-by-Id/${contactId}`);
  }
  deleteOrganizationAddress(addressId: string) {
    return this.http.get<void>(`/api/organizations/delete-organization-address-by-Id/${addressId}`);
  }

  getAllOrganizationContacts(OrganizationID: string): Observable<OrganizationContactDataModel[]> {
    return this.http.get<OrganizationContactDataModel[]>(`/api/organizations/get-all-organization-contacts/${OrganizationID}`);
  }

  getAllOrganizations(enumOrganizationTypeId: string): Observable<OrganizationDataModel[]> {
    return this.http.get<OrganizationDataModel[]>(`/api/organizations/get-all-organizations/${enumOrganizationTypeId}`);
  }

  getAllAddresses(OrganizationID: string) {
    return this.http.get<OrganizationContactDataModel>(`/api/organizations/get-all-organization-addresses/${OrganizationID}`);
  }

  getOrganization(organizationID: string): Observable<OrganizationDataModel> {
    return this.http.get<OrganizationDataModel>(`/api/organizations/${organizationID}`);
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string): Observable<EnumValidValueItemModel[]> {
    return this.http.get<EnumValidValueItemModel[]>(`/api/accountReceivable/getEnumValidValueItemsByValidValueName/${ValidValueName}`);
  }

  saveOrganizationAddresses(organizationContact: AddressDataModel[], organizationId: string) {
    return this.http.post<OrganizationAddressDataModel[]>(`/api/organizations/save-organization-addresses/${organizationId}`, organizationContact);
  }

  saveOrganizationContacts(organizationContact: ContactDataModel[], organizationId: string) {
    return this.http.post<OrganizationContactDataModel[]>(`/api/organizations/save-organization-contacts/${organizationId}`, organizationContact);
  }
}
